import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent,
  DialogContentText,
  IconButton
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LinkOffIcon from '@mui/icons-material/LinkOff';

interface ConfirmationButtonDialogProps {
  id?: number;
  message?: string;
  iconButton?: boolean;
  handleUnlink?: (id?: number, pars?: string) => void;
  pars?: string; // unlink "fonti di costi"
}

export default function ConfirmationUnlinkButtonDialog(params: ConfirmationButtonDialogProps) {
  const { id, iconButton, message, handleUnlink, pars } = params;
  const { t } = useTranslation();

  const [openDialog, setOpenDialog] = useState(false);

  /**
   * Opens the confirmation dialog for deleting a row.
   *
   * @param {number} id - The ID of the row to be deleted.
   */
  const handleOpenDialog = () => {
    // Set the selected row ID and open the dialog.
    setOpenDialog(true);
  };

  /**
   * Closes the confirmation dialog.
   */
  const handleCloseDialog = () => {
    // Close the dialog and reset the selected row ID.
    setOpenDialog(false);
  };

  const handleConfirmUnlink = () => {
    handleUnlink(id ? id : null, pars ? pars : null);
    // Close the dialog and reset the selected row ID.
    setOpenDialog(false);
  };

  return (
    <>
      {/* cosa cambia da Button ---- a ----- IconButton ?? */}
      {iconButton ? (
        <IconButton onClick={handleOpenDialog} color="error">
          <LinkOffIcon />
        </IconButton>
      ) : (
        <Button onClick={handleOpenDialog} color="error">
          <LinkOffIcon /> {t('actions.unlink')}
        </Button>
      )}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>{t('actions.confirmation.unlink')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{message ? message : ''}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            {t('actions.cancel')}
          </Button>
          <Button onClick={handleConfirmUnlink} color="primary" autoFocus>
            {t('actions.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
